import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    setIsMobileMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm py-3' : 'bg-white py-5'}`} data-id="element-94">
      <div className="max-w-[1100px] mx-auto px-6 flex items-center justify-between" data-id="element-95">
        {/* Logo */}
        <div className="flex items-center" data-id="element-96">
          <a href="#" onClick={e => {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }} className="text-forest font-outfit font-bold text-xl md:text-2xl tracking-tight" data-id="element-97">
            Xander Winther
          </a>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-98">
          <button onClick={() => scrollToSection('services')} className="text-charcoal hover:text-copper transition-colors font-medium text-sm" data-id="element-99">
            Services
          </button>
          <button onClick={() => scrollToSection('about')} className="text-charcoal hover:text-copper transition-colors font-medium text-sm" data-id="element-100">
            About
          </button>
          <button onClick={() => scrollToSection('contact')} className="text-charcoal hover:text-copper transition-colors font-medium text-sm" data-id="element-101">
            Contact
          </button>
          <button onClick={() => scrollToSection('contact')} className="bg-copper text-white px-6 py-2.5 rounded-full font-medium text-sm hover:bg-[#A6683C] transition-all hover:-translate-y-0.5 hover:shadow-lg" data-id="element-102">
            Get a Free Quote
          </button>
        </nav>

        {/* Mobile Menu Button */}
        <button className="md:hidden text-forest p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-103">
          {isMobileMenuOpen ? <X size={24} data-id="element-104" /> : <Menu size={24} data-id="element-105" />}
        </button>
      </div>

      {/* Mobile Navigation */}
      <AnimatePresence data-id="element-106">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-gray-100 overflow-hidden" data-id="element-107">
            <div className="px-6 py-6 flex flex-col space-y-4" data-id="element-108">
              <button onClick={() => scrollToSection('services')} className="text-left text-charcoal font-medium py-2 border-b border-gray-50" data-id="element-109">
                Services
              </button>
              <button onClick={() => scrollToSection('about')} className="text-left text-charcoal font-medium py-2 border-b border-gray-50" data-id="element-110">
                About
              </button>
              <button onClick={() => scrollToSection('contact')} className="text-left text-charcoal font-medium py-2 border-b border-gray-50" data-id="element-111">
                Contact
              </button>
              <button onClick={() => scrollToSection('contact')} className="bg-copper text-white w-full py-3 rounded-full font-medium mt-2" data-id="element-112">
                Get a Free Quote
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}